import React from 'react'
import './nav.css'
import {HiHome} from 'react-icons/hi'
import {BiUserPin} from 'react-icons/bi'
import {GiSecretBook} from 'react-icons/gi'
import {MdDesignServices} from 'react-icons/md'
import {BiMessageDetail} from 'react-icons/bi'
import { useState } from 'react'

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#top')
  return (
    <nav>
      <a title='Home' href="#top" onClick={() => setActiveNav('#top')} className={activeNav === '#top' ? 'active' : ''}><HiHome /></a>
      <a title='About' href="#about" onClick={() => setActiveNav('#about')} className={activeNav === '#about' ? 'active' : ''}><BiUserPin /></a>
      <a title='Experience' href="#experience" onClick={() => setActiveNav('#experience')} className={activeNav === '#experience' ? 'active' : ''}><GiSecretBook /></a>
      <a title='Services' href="#services" onClick={() => setActiveNav('#services')} className={activeNav === '#services' ? 'active' : ''}><MdDesignServices /></a>
      <a title='Contact' href="#contact" onClick={() => setActiveNav('#contact')} className={activeNav === '#contact' ? 'active' : ''}><BiMessageDetail /></a>
    </nav>
  )
}

export default Nav